import { Injectable } from '@angular/core';

import { VisualizacaoModo } from '../../../../common/visualizacao-modo';
import { SessionStorageService } from '../../../../core';
import { CampanhaVisualizacao } from './campanha-visualizacao';

/**
 * Service utilizado para armazenar os dados de visualização das campanhas no session storage do navegador
 */
@Injectable({
    providedIn: 'root'
})
export class CampanhaVisualizacaoStorageService {
    constructor(private sessionStorageService: SessionStorageService) { }

    /** Obtem o storage da visualização das campanhas no Session Storage do navegador */
    get(key: string, modo: VisualizacaoModo): CampanhaVisualizacao {
        const storage = this.sessionStorageService.getObject(key);
        if (!storage) {
            return new CampanhaVisualizacao(modo);
        }
        return storage as CampanhaVisualizacao;
    }

    /** Seta o storage da visualização das campanhas no Session Storage do navegador */
    set(key: string, storage: CampanhaVisualizacao) {
        this.sessionStorageService.setObject(key, storage);
    }

    /** Remove o storage da visualização das campanhas no Session Storage do navegador */
    remove(key: string) {
        this.sessionStorageService.remove(key);
    }
}
